import { create, enforce, test } from 'vest';

import { CANADA } from '../ContactDetailsStep/consts';
import { caZipCodeRegExp, usZipCodeRegExp } from '../ContactDetailsStep/validation';
import { PaymentFormFields } from './types';

type SuiteConfig = {
  requiredCardOnFile: boolean;
};

const CHARACTER_LIMIT = 200;
const usOrcaZipCodeRegExp = new RegExp(`(${usZipCodeRegExp.source})|(${caZipCodeRegExp.source})`, 'i');

export const zipCodeSuite = create((value: string) => {
  test('zipCode', () => {
    enforce(value).message(`Zip code is required`).isNotEmpty();
    enforce(value)
      .message(`Zip code is not valid`)
      .condition(() => usOrcaZipCodeRegExp.test(value));
  });
});

const suite = create((values: PaymentFormFields, config: SuiteConfig) => {
  test('name', () => {
    enforce(values.name).message('First name is required').isNotEmpty();
    enforce(values.name.length).message(`Max character limit: ${CHARACTER_LIMIT}`).lessThan(CHARACTER_LIMIT);
  });

  test('country', () => {
    enforce(values.country).message('Country is required').isNotEmpty();
  });

  const isCanada = values.country === CANADA;

  test('zipCode', () => {
    enforce(values.zipCode)
      .message(`${isCanada ? 'Postal' : 'Zip'} code is required`)
      .isNotEmpty();
    enforce(values.zipCode)
      .message(`${isCanada ? 'Postal' : 'Zip'} code is not valid`)
      .condition((value) => (values.country === 'Canada' ? caZipCodeRegExp : usZipCodeRegExp).test(value));
  });
  test('saveCard', () => {
    if (config.requiredCardOnFile) {
      enforce(values.saveCard).message('Required').isNotEmpty();
    }
  });
});

export const onPaymentFormValidate = (config: SuiteConfig) => (values: PaymentFormFields) => {
  const { getErrors } = suite(values, config);
  const errors = getErrors();

  return errors;
};
